import { gpCommon } from '../app';
import { IconService, ICON_UPLOAD_ERROR_TOO_BIG } from '../services/icons-service';
import { UploadService, IUploadService } from '../services/fileupload-service';



export interface FilesUploadResult {
    files: FileUploadResult[];
}

export interface FileUploadResult {
    url: string;
    id: string;
}

export type UploadTargetCategories = 'public' | 'companylogo' | 'private';


interface IDragDropUploaderScopeBase extends ng.IScope {
    onFinishedUploading(args: { result: FilesUploadResult }): void;
    errorMessage: string;
}
interface IDragDropUploaderScope extends IDragDropUploaderScopeBase {
    iconTarget: string;
}

interface IGenericDragDropUploaderScope extends IDragDropUploaderScopeBase {
    uploadUrl(): string;
}

function doUpload(target: UploadTargetCategories, iconService: IconService, files: FileList) {
    if (target === "public") {
        return iconService.uploadPublicIcons(files);
    } if (target === 'companylogo') {
        return iconService.uploadCompanyLogo(files);
    } else if (target === 'private') {
        return iconService.uploadPersonalIcons(files);
    } else {
        const unusedVal: never = target;
        throw new Error("Not implemented")
    }
}

function linkUploaderDirective(
    $scope: IDragDropUploaderScopeBase,
    jElement: ng.IAugmentedJQuery,
    performUpload: (files: FileList) => ng.IPromise<FilesUploadResult>) {

    var element = $(jElement)[0];

    var insideDropCount = 0;
    $scope.errorMessage = "";
    const finishedUploading = (result: FilesUploadResult) => {
        if ($scope.onFinishedUploading) {
            $scope.onFinishedUploading({ result: result });
        }
    };

    function dragUpdate() {
        if (insideDropCount > 0) {
            $(jElement).addClass("drag-over");
        } else {
            $(jElement).removeClass("drag-over");
        }
    }

    function dragClear() {
        insideDropCount = 0;
        dragUpdate();
    }

    function dragEnter() {
        ++insideDropCount;
        dragUpdate();
    }

    function dragLeave() {
        --insideDropCount;
        dragUpdate();
    }

    function formatError(msg: string): string {
        if (msg === ICON_UPLOAD_ERROR_TOO_BIG) {
            return "The image is too large. Please upload an image no larger than 1024 x 1024 pixels.";
        } else {
            return msg;
        }
    }

    element.addEventListener('dragenter', (ev: DragEvent) => dragEnter());
    element.addEventListener('dragleave', (ev: DragEvent) => dragLeave());

    element.addEventListener('drop', (ev: DragEvent) => {
        dragClear();
        ev.preventDefault();

        $scope.errorMessage = "";

        if (ev.dataTransfer && ev.dataTransfer.files) {
            performUpload(ev.dataTransfer.files)
                .then(result => finishedUploading(result))
                .catch(reason => $scope.errorMessage = formatError(reason))
        }

        return false;
    });

    element.addEventListener('dragover', ev => { ev.preventDefault(); return false; });
    element.addEventListener('dragenter', ev => { ev.preventDefault(); return false; });

    element.addEventListener('click', (ev: MouseEvent) => {
        var input: HTMLInputElement = document.createElement('input');
        input.accept = ".png, .jpg";
        input.type = "file";
        // Safari on mac only allows the change event if the element has been added to the dom.
        // TODO: Work out a way to remove the element if the user cancels the popup dialog
        input.style.display = "none";
        document.body.appendChild(input);

        $(element).on('$destroy', () => {
            input.remove();
        });

        input.addEventListener('change', (ev) => {
            $scope.errorMessage = "";
            if (input.files) {
                performUpload(input.files)
                    .then(result => finishedUploading(result))
                    .catch(reason => $scope.errorMessage = formatError(reason))
            }
            input.remove();
        });
        input.click();
    });
}

gpCommon.directive("gpDragDropUploader", [IconService.serviceName, function (gpIconService: IconService): ng.IDirective<IDragDropUploaderScope> {
    return ({
        scope: {
            onFinishedUploading: "&onFinishedUploading",
            iconTarget: "@iconTarget",
            errorMessage: '=errorMessage',
        },
        link: ($scope: IDragDropUploaderScope, jElement: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any) => {
            linkUploaderDirective($scope, jElement, files => doUpload(stringToIconTarget($scope.iconTarget), gpIconService, files));

        },

    })
}]);

gpCommon.directive("gpFileDragDropUploader", [UploadService.serviceName, function (gpUploadService: IUploadService): ng.IDirective<IGenericDragDropUploaderScope> {
    return ({
        scope: {
            onFinishedUploading: "&onFinishedUploading",
            uploadUrl: "&uploadUrl",
            errorMessage: '=errorMessage',
        },
        link: ($scope: IGenericDragDropUploaderScope, jElement: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any) => {
            linkUploaderDirective($scope, jElement, files => {
                $scope.errorMessage = "Want to upload to " + $scope.uploadUrl();

                return gpUploadService.uploadFiles($scope.uploadUrl(), files)
            });
        },

    })
}]);

function stringToIconTarget(iconTarget: string): UploadTargetCategories {
    if (iconTarget === 'public') {
        return iconTarget;
    } else if (iconTarget === 'private') {
        return iconTarget;
    } else if (iconTarget === 'companylogo') {
        return iconTarget;
    } else {
        return 'private';
    }
}
